export const MAIN_MENU = 'mainMenu'
export const MAIN_MENU_BUTTON = 'mainMenuButton'
export const ACCOUNT_MENU_BUTTON = 'account-menu'
